/**
 * @file 基础工具
 */
import { lineEnum } from '@/core/constant';
import { getLiveStreamInfoById } from '@/core/stream';
import qs from 'query-string';

/**
 * 获取url的query参数键值对
 */
export function generateParams() {
  return qs.parse(window.location.search, { parseBooleans: true });
}

type PRELOAD_SOURCE_TYPE = { type: string; url: string };

/**
 * config生成工具函数
 */
const SourceHelper = (type: string, urlMap: Record<string, string>) => {
  const res = {} as Record<string, PRELOAD_SOURCE_TYPE>;
  Object.keys(urlMap).forEach(k => {
    res[k] = {
      type,
      url: urlMap[k]
    };
  });
  return res;
};

/**
 * 发送天马的log
 * @param logName
 * @param config
 */
export const sendPegasusLog = (action: string, params?: any) => {
  try {
    // @ts-ignore
    if (window._rlog) {
      // @ts-ignore
      const { _rlog } = window;
      if (params) {
        const keysArr = Reflect.ownKeys(params);
        keysArr.forEach(item => {
          _rlog.push(['_addPost', item, params[item]]);
        });
        _rlog.push(['_trackEvent', action]);
        keysArr.forEach(item => {
          _rlog.push(['_removePost', item]);
        });
      } else {
        _rlog.push(['_trackEvent', action]);
      }
    }
  } catch (e) {
    console.error(e);
  }
};

/**
 * 文件下载
 * @param src 下载路径
 */
export const download = (src: string) => {
  const link = document.createElement('a');
  link.href = src;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const ua = navigator.userAgent.toLowerCase();

const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone', 'blackberry'];

// 检测屏幕宽度
var screenWidth =
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var isSmallScreen = screenWidth < 400;

var isMobileDevice = mobileKeywords.some((keyword: string) => ua.includes(keyword));

export const isWxBrowser = /micromessenger/i.test(ua);
export const isPOPOBrowser = /popo/i.test(ua);
export const isYD = window.ydk && window.ydk.isYD;
export const isIOS = !!ua.match(/iphone|ipad|ipod/i);
export const isMobile = isMobileDevice || isSmallScreen;
export const isLiveStreamType = !isMobile ? 'flv' : 'hls';
export const isLandscape =
  isMobile &&
  (window.matchMedia('(orientation: landscape)') || window.innerWidth > window.innerHeight);

/**
 * 获取视频流列表
 */
export const getStreamList = (lineNum: lineEnum) => {
  const { id } = generateParams() || {};
  const liveId = id || 1;
  // @ts-ignore
  const stream = getLiveStreamInfoById(liveId);
  return stream?.[lineNum]?.[isLiveStreamType];
};

/**
 * 页面跳转
 * @param newId 新的id
 * @param url 传入的url
 */
export const redirectToNewId = (newId: string, url?: string) => {
  const currentUrl = url || window.location.href;
  const urlObj = new URL(currentUrl);
  urlObj.searchParams.set('id', newId.toString());

  // 跳转到新地址并替换当前历史记录
  window.history.replaceState(null, '', urlObj.toString());
  window.location.reload();
};

/**
 * 通过类名查询元素宽度
 * @param className
 * @returns
 */
export const getElementWidth = (className: string): number | null => {
  const element = document.querySelector(`.${className}`);
  if (element) {
    // 获取元素的尺寸
    const rect = element.getBoundingClientRect();
    // 返回元素的宽度
    return rect.width;
  }
  // 如果找不到元素，返回 null
  return null;
};

/**
 * 通过类名查询元素宽度
 * @param className
 * @returns
 */
export const getElementHeight = (className: string): number | null => {
  const element = document.querySelector(`.${className}`);
  if (element) {
    // 获取元素的尺寸
    const rect = element.getBoundingClientRect();
    // 返回元素的宽度
    return rect.height;
  }
  // 如果找不到元素，返回 null
  return null;
};

/**
 * 封装一个函数专门处理样式覆盖
 */
export const setElementStyle = (element: HTMLElement, styleProperty: string, value: string) => {
  try {
    if (element && typeof styleProperty === 'string') {
      // @ts-ignore
      (element as HTMLElement).style[styleProperty] = value;
    } else {
      console.error(`Element with class not found`);
    }
  } catch {
    //
    console.log('样式异常');
  }
};
